import { contains, genHexString, copyToClibpoard } from './string';
import { random, renderCommaFloat } from './int';
import { diffDays } from './dates';
import { getCookieValue } from './cookies';
import { toFormData } from './forms';
import { stateColor, stateIcon } from './obligation';
import { fileIcon } from './files';
import { lightenDarkenColor } from './colors';
import { logout } from './auth';

export default {
  string: {
    contains,
    genHexString,
    copyToClibpoard,
  },
  int: {
    random,
    renderCommaFloat,
  },
  dates: {
    diffDays,
  },
  cookies: {
    getCookieValue,
  },
  forms: {
    toFormData,
  },
  files: {
    fileIcon,
  },
  // Worldlex specifics//
  obligation: {
    stateColor,
    stateIcon,
  },
  colors: {
    lightenDarkenColor,
  },
  auth: {
    logout,
  },
};
